import {
    ICloudFileDatabasePage,
    ICloudFolder,
    IPushpin,
    IPushpinType,
    IServiceResult,
    IStore,
    IStoreType,
    ITerritory,
    ITerritoryType,
    IMyDataImportResult,
    ICloudFile, ITargetMarketDeveloperType, ITargetMarketLocation,
} from "../Models/Models";

export interface IMyDataAxios {
  GetCloudIcons(url): Promise<IServiceResult<any>>;
  SubmitImport(data, url): Promise<IServiceResult<IMyDataImportResult>>;
  DeleteCloudFolder(data): Promise<IServiceResult<ICloudFolder>>;
  AddCloudFolder(data): Promise<IServiceResult<ICloudFolder>>;
  UpdateCloudFile(data): Promise<IServiceResult<ICloudFile>>;
  DeleteCloudFile(data): Promise<IServiceResult<ICloudFolder>>;
  GetStoreTypes(): Promise<IServiceResult<IStoreType>>;
  GetStoreData(data): Promise<IServiceResult<IStore>>;
  GetPushpinTypes(): Promise<IServiceResult<IPushpinType>>;
  GetPushpinData(data): Promise<IServiceResult<IPushpin>>;
  GetTerritoryTypes(): Promise<IServiceResult<ITerritoryType>>;
  GetTerritoryData(data): Promise<IServiceResult<ITerritory>>;
  GetAreasOfInterestPointTypes(): Promise<IServiceResult<ICloudFolder>>;
  GetAreasOfInterestPointData(
    data
  ): Promise<IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>>;
  GetAreasOfInterestShapeTypes(): Promise<IServiceResult<ICloudFolder>>;
  GetAreasOfInterestShapeData(
    data
  ): Promise<IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>>;
  GetResultsPointTypes(): Promise<IServiceResult<ICloudFolder>>;
  GetResultsPointData(
    data
  ): Promise<IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>>;
  GetResultsShapeTypes(): Promise<IServiceResult<ICloudFolder>>;
  GetResultsShapeData(
    data
  ): Promise<IServiceResult<ICloudFileDatabasePage<{ [key: string]: string }>>>;
  GetTargetMarkets(): Promise<IServiceResult<ITargetMarketDeveloperType>>;
  GetTargetMarketData(data): Promise<IServiceResult<ITargetMarketLocation>>;
}
